import { Modal, Button } from "src/Components";
import { CoveredMatrixOrderPreviewResult } from "src/Interfaces/coveredMatrixOrder";
import OrderPreview from "../OrderPreview";

export const PreviewModal = ({ preview, baseReferencePrice, onClose, onSubmit }: {
  preview: CoveredMatrixOrderPreviewResult;
  baseReferencePrice: number | null;
  onClose: () => void;
  onSubmit: () => void;
}) => (
  <Modal
    onClose={onClose}
    modalBoxClassName="!w-[1320px] !min-w-0 !max-w-[95vw]"
    UI={<div className="flex min-w-0 flex-col gap-4" dir="rtl">
      <OrderPreview preview={preview} baseReferencePrice={baseReferencePrice} />
      <div className="sticky bottom-0 z-10 flex shrink-0 justify-between gap-3 border-t border-slate-200 bg-white py-3">
        <Button variant="outlined" text="بازگشت" onClick={onClose} className="!w-28" />
        <Button variant="contained" text="تأیید و ارسال" onClick={onSubmit} disabled={!preview.rows.length} className="!w-32" />
      </div>
    </div>}
  />
);
